import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '../../shared.service';
import { AboutTyler } from './about-tyler.model';
import { LoginService } from '../../../shared-modules/login/login.service';
import { LoginSettings } from '../../../shared-modules/login/LoginSetting.model';

@Component({
    selector: 'app-about-panel',
    templateUrl: './about-panel.component.html'
})
export class AboutPanelComponent implements OnInit {

    aboutTyler: AboutTyler;
    legacyVersion: String
    currentDate: Date;
    loginSettings: LoginSettings;

    constructor(
        private dialog: MatDialogRef<AboutPanelComponent>,
        private sharedService: SharedService,
        private loginService: LoginService
    ) {
        this.legacyVersion = this.loginService.LoginSettings.LegacyVersion;
        this.loginSettings = this.loginService.LoginSettings;
    }

    ngOnInit() {
        this.sharedService.getAboutTylerSIS().subscribe((results) => {
            this.aboutTyler = results;
        });
        this.currentDate = new Date();
    }

    closeClick() {
        this.dialog.close();
    }

}
